<!--
 * @description: 
 * @Author: liwg
 * @Date: 2022-07-13 19:57:28
 * @LastEditors: liwg
 * @LastEditTime: 2022-09-19 16:31:46
-->
<template>
  <ConfigProvider :locale="getAntdLocale" :theme="themeConfig">
    <NsProvider :http="http" :icon-url="iconConfig.url">
      <AppProvider>
        <StyleProvider hash-priority="high" :transformers="[legacyLogicalPropertiesTransformer]">
          <RouterView :class="`ns-dark h-full ${projectName}`" />
        </StyleProvider>
      </AppProvider>
    </NsProvider>
    <div id="components-back-top-demo-custom">
      <a-back-top>
        <div class="ant-back-top-inner">UP</div>
      </a-back-top>
    </div>
  </ConfigProvider>
</template>
<script lang="ts" setup>
import { NsProvider } from '@ns/ui'
import {
  ConfigProvider,
  StyleProvider,
  legacyLogicalPropertiesTransformer,
  theme
} from 'ant-design-vue'
import dayjs from 'dayjs'
import { ref, watch } from 'vue'
import { useLangStore } from '@/store/lang'
import { useAppStore } from '@/store/app'
import AppProvider from '@/components/Application/AppProvider.vue'
import { http } from '@/utils/http'
import { iconConfig } from '@/config/icon'
import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
const { getAntdLocale } = useLangStore()
const { portingConfig, projectName } = usePortingConfig()
useTitle(portingConfig.title)
useFavicon(portingConfig.favicon)
const appStore = useAppStore()
const themeConfig = ref<ThemeConfig>({
  token: {
    borderRadius: 2,
    colorPrimary: '#165DFF',
    colorLink: '#165DFF',
    colorLinkHover: '#165DFF',
    colorLinkActive: '#165DFF',
    colorBorder: 'var(--ns-line-2)',
    colorTextPlaceholder: 'var(--ns-text-2)',
    fontFamily:
      '阿里巴巴普惠体,Helvetica Neue,PingFang SC,Noto Sans,Noto Sans CJK SC,Microsoft YaHei,微软雅黑'
  },
  components: {
    Form: {
      colorTextHeading: 'var(--ns-text-3)'
    }
  }
})
watch(
  () => appStore.model,
  (val) => {
    if (val === 'dark') {
      themeConfig.value.algorithm = theme.darkAlgorithm
    } else {
      themeConfig.value.algorithm = theme.defaultAlgorithm
    }
  },
  {
    immediate: true,
    deep: true
  }
)
</script>
<style lang="less">
#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
  right: 60px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: @primary-color;
  color: #fff;
  text-align: center;
  font-size: 20px;
}
</style>
